import Vue from 'vue';
import router from '@/main/baseRouter';
import store from '@/main/baseStore';
import App from '@/App.vue';
import PlatformNotFoundPage from '@/authentication/page/PlatformNotFoundPage.vue';

export function renderApp(params: { isPlatformFound: boolean }) {
    const elementSelector = '#app';

    if (params.isPlatformFound) {
        new Vue({
            router,
            store,
            render: create => create(App),
        }).$mount(elementSelector);
    } else {
        new Vue({
            store,
            render: create => create(PlatformNotFoundPage),
        }).$mount(elementSelector);
    }
}
